export const PriceTypeEnum = Object.freeze({
    PER_PERSON: 'per-person',
    PER_UNIT: 'per-unit',
    PER_NIGHT_PER_PERSON: 'per-night-per-person',
    PER_DAY_PER_PERSON: 'per-day-per-person',
    PER_DAY_PER_UNIT: 'per-day-per-unit',
    PER_NIGHT_PER_UNIT: 'per-night-per-unit',
});

export function isPerPerson(service) {
    return service.price_type === PriceTypeEnum.PER_PERSON;
}

export function isPerUnit(service) {
    return service.price_type === PriceTypeEnum.PER_UNIT;
}

export function isPerNightPerPerson(service) {
    return service.price_type === PriceTypeEnum.PER_NIGHT_PER_PERSON;
}

export function isPerDayPerPerson(service) {
    return service.price_type === PriceTypeEnum.PER_DAY_PER_PERSON;
}

export function isPerDayPerUnit(service) {
    return service.price_type === PriceTypeEnum.PER_DAY_PER_UNIT;
}

export function isPerNightPerUnit(service) {
    return service.price_type === PriceTypeEnum.PER_NIGHT_PER_UNIT;
}

export function isPerPersonBased(service) {
    return [PriceTypeEnum.PER_PERSON, PriceTypeEnum.PER_NIGHT_PER_PERSON, PriceTypeEnum.PER_DAY_PER_PERSON].includes(
        service.price_type
    );
}

export function isPerDayBased(service) {
    return [PriceTypeEnum.PER_DAY_PER_PERSON, PriceTypeEnum.PER_DAY_PER_UNIT].includes(service.price_type);
}

export function isPerUnitBased(service) {
    return [PriceTypeEnum.PER_UNIT, PriceTypeEnum.PER_DAY_PER_UNIT, PriceTypeEnum.PER_NIGHT_PER_UNIT].includes(
        service.price_type
    );
}

export const PriceType = {
    isPerPerson,
    isPerUnit,
    isPerNightPerPerson,
    isPerDayPerPerson,
    isPerDayPerUnit,
    isPerNightPerUnit,
    isPerDayBased,
    isPerPersonBased,
    isPerUnitBased,
};

export const PriceTypeMixin = {
    computed: {
        priceTypeOptions() {
            let options = [];
            Object.keys(PriceTypeEnum).forEach((priceType) => {
                options.push({
                    value: PriceTypeEnum[priceType],
                    displayName: this.priceTypeDisplayName(PriceTypeEnum[priceType]),
                });
            });
            return options;
        },
    },
    methods: {
        priceTypeDisplayName(priceType) {
            let displayNameMap = {};
            displayNameMap[PriceTypeEnum.PER_PERSON] = this.$t('Per person');
            displayNameMap[PriceTypeEnum.PER_UNIT] = this.$t('Per unit');
            displayNameMap[PriceTypeEnum.PER_NIGHT_PER_PERSON] = this.$t('Per night / per person');
            displayNameMap[PriceTypeEnum.PER_DAY_PER_PERSON] = this.$t('Per day / per person');
            displayNameMap[PriceTypeEnum.PER_DAY_PER_UNIT] = this.$t('Per day / per unit');
            displayNameMap[PriceTypeEnum.PER_NIGHT_PER_UNIT] = this.$t('Per night / per unit');
            return displayNameMap[priceType];
        },
        isPerPerson(service) {
            return isPerPerson(service);
        },
        isPerUnit(service) {
            return isPerUnit(service);
        },
        isPerNightPerPerson(service) {
            return isPerNightPerPerson(service);
        },
        isPerDayPerPerson(service) {
            return isPerDayPerPerson(service);
        },
        isPerDayPerUnit(service) {
            return isPerDayPerUnit(service);
        },
        isPerNightPerUnit(service) {
            return isPerNightPerUnit(service);
        },
        isPerDayBased(service) {
            return isPerDayBased(service);
        },
        isPerPersonBased(service) {
            return isPerPersonBased(service);
        },
        isPerUnitBased(service) {
            return isPerUnitBased(service);
        },
        serviceUnits(service) {
            return isPerPersonBased(service) ? this.$t('pax') : this.$t('pcs');
        },
    },
};
